// Generated by purs version 0.15.15
import * as Data_Function from "../Data.Function/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
var select_ = /* #__PURE__ */ Halogen_Styled_DSL.select_();
var select = /* #__PURE__ */ Halogen_Styled_DSL.select();
var view = function (props) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.button)("PrimaryButton")([ Halogen_Styled_DSL.scopedSheet(select_({
        height: "40px",
        backgroundColor: "black",
        color: "white",
        borderRadius: "8px",
        paddingRight: "10px",
        paddingLeft: "10px",
        width: "max-content",
        cursor: (function () {
            if (props.disabled) {
                return "auto";
            };
            return "pointer";
        })(),
        opacity: (function () {
            if (props.disabled) {
                return "0.5";
            };
            return "1";
        })(),
        fontWeight: "semi-bold"
    })), Halogen_Styled_DSL.scopedSheet(select(":hover")({
        backgroundColor: "rgba(0,0,0,0.7)"
    })) ]);
    return elRoot((function () {
        if (props.disabled) {
            return [  ];
        };
        return [ Halogen_HTML_Events.onClick(Data_Function["const"](props.onClick)) ];
    })())([ Halogen_Styled.text(props.label) ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
